export const InboxTreeItemRendererName = 'inboxTreeItemRendererComponent';
